/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteEstimaData = /* GraphQL */ `
  mutation DeleteEstimaData($input: fil_estima_point_pk) {
    deleteEstimaData(input: $input) {
      esp_est_kb_no
      esp_estima_no
    }
  }
`;
export const deleteLogMaintenance = /* GraphQL */ `
  mutation DeleteLogMaintenance($input: log_maintenance_pk) {
    deleteLogMaintenance(input: $input) {
      lm_status_kb
    }
  }
`;
export const deleteMstContractPeriod = /* GraphQL */ `
  mutation DeleteMstContractPeriod($input: mst_contract_period_pk) {
    deleteMstContractPeriod(input: $input) {
      mcp_years
    }
  }
`;
export const deleteMstHinmei = /* GraphQL */ `
  mutation DeleteMstHinmei($input: mst_hinmei_pk) {
    deleteMstHinmei(input: $input) {
      mh_hin_cd
    }
  }
`;
export const deleteMstOffice = /* GraphQL */ `
  mutation DeleteMstOffice($input: mst_office_pk) {
    deleteMstOffice(input: $input) {
      mo_office_cd
    }
  }
`;
export const deleteMstPrimarySales = /* GraphQL */ `
  mutation DeleteMstPrimarySales($input: mst_primary_sales_pk) {
    deleteMstPrimarySales(input: $input) {
      mps_primary_cd
    }
  }
`;
export const deleteMstProduct = /* GraphQL */ `
  mutation DeleteMstProduct($input: mst_product_pk) {
    deleteMstProduct(input: $input) {
      mpr_product_cd
    }
  }
`;
export const deleteMstRemarks = /* GraphQL */ `
  mutation DeleteMstRemarks($input: mst_remarks_pk) {
    deleteMstRemarks(input: $input) {
      mrm_remarks_cd
    }
  }
`;
export const deleteMstSecondarySales = /* GraphQL */ `
  mutation DeleteMstSecondarySales($input: mst_secondary_sales_pk) {
    deleteMstSecondarySales(input: $input) {
      mss_primary_cd
      mss_secondary_cd
    }
  }
`;
export const deleteMstUser = /* GraphQL */ `
  mutation DeleteMstUser($input: mst_user_pk) {
    deleteMstUser(input: $input) {
      mu_mail
    }
  }
`;
export const insertLogMaintenance = /* GraphQL */ `
  mutation InsertLogMaintenance($input: log_maintenance_all!) {
    insertLogMaintenance(input: $input) {
      lm_start_time
      lm_start_user_nm
      lm_status_kb
    }
  }
`;
export const insertMstContractPeriod = /* GraphQL */ `
  mutation InsertMstContractPeriod($input: mst_contract_period_all!) {
    insertMstContractPeriod(input: $input) {
      mcp_maintenance_discount_rate
      mcp_usage_fee_discount_rate
      mcp_years
    }
  }
`;
export const insertMstHinInfo = /* GraphQL */ `
  mutation InsertMstHinInfo($input: mst_hin_info_all!) {
    insertMstHinInfo(input: $input) {
      mhi_add_hinmei1
      mhi_add_hinmei2
      mhi_available_kb
      mhi_hin_cd
      mhi_maintenance_price
      mhi_oso_cd
      mhi_primary_cd
      mhi_product_cd
      mhi_product_price
      mhi_secondary_cd
    }
  }
`;
export const insertMstHinmei = /* GraphQL */ `
  mutation InsertMstHinmei($input: mst_hinmei_all!) {
    insertMstHinmei(input: $input) {
      mh_available_kb
      mh_discount_kb
      mh_freename_kb
      mh_hin_cd
      mh_hin_kb
      mh_hin_nm
      mh_maintenance_kb
      mh_maintenance_tani
    }
  }
`;
export const insertMstNetRate = /* GraphQL */ `
  mutation InsertMstNetRate($input: mst_net_rate_all!) {
    insertMstNetRate(input: $input) {
      mnr_license_net_rate
      mnr_maintenance_net_rate
      mnr_primary_cd
      mnr_product_cd
      mnr_secondary_cd
      mnr_software_net_rate
      mnr_template_net_rate
      mnr_useware_net_rate
    }
  }
`;
export const insertMstOffice = /* GraphQL */ `
  mutation InsertMstOffice($input: mst_office_all!) {
    insertMstOffice(input: $input) {
      mo_address
      mo_fax
      mo_office_cd
      mo_office_nm
      mo_post
      mo_tel
    }
  }
`;
export const insertMstPrimarySales = /* GraphQL */ `
  mutation InsertMstPrimarySales($input: mst_primary_sales_all!) {
    insertMstPrimarySales(input: $input) {
      mps_primary_cd
      mps_primary_nm
    }
  }
`;
export const insertMstProduct = /* GraphQL */ `
  mutation InsertMstProduct($input: mst_product_all!) {
    insertMstProduct(input: $input) {
      mpr_available_kb
      mpr_discount_type
      mpr_maintenance_limit
      mpr_product_cd
      mpr_product_nm
    }
  }
`;
export const insertMstRemarks = /* GraphQL */ `
  mutation InsertMstRemarks($input: mst_remarks_all!) {
    insertMstRemarks(input: $input) {
      mrm_remarks
      mrm_remarks_cd
      mrm_remarks_kb
    }
  }
`;
export const insertMstSecondarySales = /* GraphQL */ `
  mutation InsertMstSecondarySales($input: mst_secondary_sales_all!) {
    insertMstSecondarySales(input: $input) {
      mss_primary_cd
      mss_secondary_cd
      mss_secondary_nm
    }
  }
`;
export const insertMstUser = /* GraphQL */ `
  mutation InsertMstUser($input: mst_user_all!) {
    insertMstUser(input: $input) {
      mu_admin_kb
      mu_mail
      mu_office_cd
      mu_user_id
      mu_user_nm
    }
  }
`;
export const registerEstimaData = /* GraphQL */ `
  mutation RegisterEstimaData($input: fil_estima_data!) {
    registerEstimaData(input: $input) {
      esp_est_kb_no
      esp_estima_no
    }
  }
`;
export const registerMstControlRule = /* GraphQL */ `
  mutation RegisterMstControlRule($input: [mst_control_rule_all!]) {
    registerMstControlRule(input: $input) {
      mcr_condition1
      mcr_condition2
      mcr_condition3
      mcr_control_item
      mcr_control_kb
      mcr_process_order
    }
  }
`;
export const updateMstContractPeriod = /* GraphQL */ `
  mutation UpdateMstContractPeriod($input: mst_contract_period_all!) {
    updateMstContractPeriod(input: $input) {
      mcp_maintenance_discount_rate
      mcp_usage_fee_discount_rate
      mcp_years
    }
  }
`;
export const updateMstHinInfo = /* GraphQL */ `
  mutation UpdateMstHinInfo($input: mst_hin_info_all!) {
    updateMstHinInfo(input: $input) {
      mhi_add_hinmei1
      mhi_add_hinmei2
      mhi_available_kb
      mhi_hin_cd
      mhi_maintenance_price
      mhi_oso_cd
      mhi_primary_cd
      mhi_product_cd
      mhi_product_price
      mhi_secondary_cd
    }
  }
`;
export const updateMstHinmei = /* GraphQL */ `
  mutation UpdateMstHinmei($input: mst_hinmei_all!) {
    updateMstHinmei(input: $input) {
      mh_available_kb
      mh_discount_kb
      mh_freename_kb
      mh_hin_cd
      mh_hin_kb
      mh_hin_nm
      mh_maintenance_kb
      mh_maintenance_tani
    }
  }
`;
export const updateMstNetRate = /* GraphQL */ `
  mutation UpdateMstNetRate($input: mst_net_rate_all!) {
    updateMstNetRate(input: $input) {
      mnr_license_net_rate
      mnr_maintenance_net_rate
      mnr_primary_cd
      mnr_product_cd
      mnr_secondary_cd
      mnr_software_net_rate
      mnr_template_net_rate
      mnr_useware_net_rate
    }
  }
`;
export const updateMstOffice = /* GraphQL */ `
  mutation UpdateMstOffice($input: mst_office_all!) {
    updateMstOffice(input: $input) {
      mo_address
      mo_fax
      mo_office_cd
      mo_office_nm
      mo_post
      mo_tel
    }
  }
`;
export const updateMstPrimarySales = /* GraphQL */ `
  mutation UpdateMstPrimarySales($input: mst_primary_sales_all!) {
    updateMstPrimarySales(input: $input) {
      mps_primary_cd
      mps_primary_nm
    }
  }
`;
export const updateMstProduct = /* GraphQL */ `
  mutation UpdateMstProduct($input: mst_product_all!) {
    updateMstProduct(input: $input) {
      mpr_available_kb
      mpr_discount_type
      mpr_maintenance_limit
      mpr_product_cd
      mpr_product_nm
    }
  }
`;
export const updateMstRemarks = /* GraphQL */ `
  mutation UpdateMstRemarks($input: mst_remarks_all!) {
    updateMstRemarks(input: $input) {
      mrm_remarks
      mrm_remarks_cd
      mrm_remarks_kb
    }
  }
`;
export const updateMstSecondarySales = /* GraphQL */ `
  mutation UpdateMstSecondarySales($input: mst_secondary_sales_all!) {
    updateMstSecondarySales(input: $input) {
      mss_primary_cd
      mss_secondary_cd
      mss_secondary_nm
    }
  }
`;
export const updateMstUser = /* GraphQL */ `
  mutation UpdateMstUser($input: mst_user_all!) {
    updateMstUser(input: $input) {
      mu_admin_kb
      mu_mail
      mu_office_cd
      mu_user_id
      mu_user_nm
    }
  }
`;
